import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import "./ProductPage.css";
import Breadcrumb from "../Breadcrum";

// Example product data array (the same as the one you provided)
const cardData = [
  {
    id: "gourmet-dinner-plates",
    cards: [
      {
        cardId: "card1",
        title: '6" SQUARE PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_38.jpg",
      },
      {
        cardId: "card2",
        title: '7" SQUARE PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_39.jpg",
      },
      {
        cardId: "card3",
        title: '8" SQUARE PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_42.jpg",
      },
      {
        cardId: "card4",
        title: '9" SQUARE PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_17.jpg",
      },
      {
        cardId: "card5",
        title: '10" SQUARE PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_40.jpg",
      },
      {
        cardId: "card6",
        title: '6"X5" RECTANGLE DEEP',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_32.jpg",
      },
      {
        cardId: "card7",
        title: '9"X6" RECTANGLE DEEP',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_31.jpg",
      },
      {
        cardId: "card8",
        title: '9"X6" RECTANGLE SHALLOW',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_30.jpg",
      },
      {
        cardId: "card9",
        title: '9"X6" RECTANGLE DUO',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_29.jpg",
      },
      {
        cardId: "card10",
        title: '12"X9.5" RECTANGLE PARTITION',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_28.jpg",
      },
    ],
  },
  {
    id: "snack-platters",
    cards: [
      {
        cardId: "card1",
        title: '10" ROUND 3 PARTITION',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_33.jpg",
      },
      {
        cardId: "card2",
        title: '6" ROUND PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_35.jpg",
      },
      {
        cardId: "card3",
        title: '9" ROUND PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_36.jpg",
      },
      {
        cardId: "card4",
        title: '7" ROUND DEEP PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_37.jpg",
      },
      {
        cardId: "card5",
        title: '10" ROUND DEEP PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_34.jpg",
      },
      {
        cardId: "card6",
        title: '9" ROUND SOUP PLATE',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_24.jpg",
      },
      {
        cardId: "card7",
        title: "CAFÉ OVAL 26 CMS",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_26.jpg",
      },
      {
        cardId: "card8",
        title: "KIDS PLATE BEAR 22 CM",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_23.jpg",
      },
      {
        cardId: "card9",
        title: "CAFÉ OVAL 17 CMS",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_27.jpg",
      },
      {
        cardId: "card10",
        title: "SNACK PLATE 14 CMS",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_25.jpg",
      },
    ],
  },
  {
    id: "soup-salad-bowls",
    cards: [
      {
        cardId: "card1",
        title: '7" ROUND BOWL - 700 ML',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_20.jpg",
      },
      {
        cardId: "card2",
        title: '6" ROUND BOWL - 450 ML',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_22.jpg",
      },
      {
        cardId: "card3",
        title: '4" ROUND BOWL - 120 ML',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_7.jpg",
      },
      {
        cardId: "card4",
        title: '5" ROUND BOWL - 250 ML',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_10.jpg",
      },
      {
        cardId: "card5",
        title: '8" SQUARE DEEP BOWL - 900 ML',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_16.jpg",
      },
      {
        cardId: "card6",
        title: '5" SQUARE BOWL - 300 ML',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_41.jpg",
      },
      {
        cardId: "card7",
        title: '7" SQUARE BOWL - 600 ML',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_8.jpg",
      },
      {
        cardId: "card8",
        title: '7" SQUARE BOWL - 600 ML',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_15.jpg",
      },
    ],
  },
  {
    id: "party-serving-trays",
    cards: [
      {
        cardId: "card1",
        title: '15" X 3" SUSHI TRAY',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_1.jpg",
      },
      {
        cardId: "card2",
        title: '13" X 11" RECTANGLE TRAY',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_3.jpg",
      },
      {
        cardId: "card3",
        title: '13" X 7" RECT TRAY',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_4.jpg",
      },
      {
        cardId: "card4",
        title: '15" X 10" OVAL TRAY',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_2.jpg",
      },
      {
        cardId: "card5",
        title: '11" FLAT ROUND',
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_5.jpg",
      },
      {
        cardId: "card6",
        title: "PALM BOAT - 800 ML",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_11.jpg",
      },
      {
        cardId: "card7",
        title: "SNACK TRAY - 200 ML",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_14.jpg",
      },
      {
        cardId: "card8",
        title: "SNACK TRAY - 400 ML",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_13.jpg",
      },
      {
        cardId: "card9",
        title: "PALM BOAT - 400 ML",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_12.jpg",
      },
    ],
  },
  {
    id: "custom-shapes-sizes",
    cards: [
      {
        cardId: "card1",
        title: "SQUARE CANOPY 8 CM",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_18.jpg",
      },
      {
        cardId: "card2",
        title: "ROUND DIP - 50 ML",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_21.jpg",
      },
      {
        cardId: "card3",
        title: "ROUND CANOPY 10 CM",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_19.jpg",
      },
      {
        cardId: "card4",
        title: "ROUND DIP - 30 ML",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_9.jpg",
      },
      {
        cardId: "card5",
        title: "RECTANGLE CANOPY 16X8 CM",
        image:
          "./assets/img/ecoPalmProducts/productCards/gournmetPlates/ECO_6.jpg",
      },
    ],
  },
];

export default function ProductPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { productId } = useParams();
  let productHeading =productId.split("-").join(" ")
  // Using switch to return the corresponding product data
  let productData = {};

  switch (productId) {
    case "gourmet-dinner-plates":
      productData = cardData.find(
        (product) => product.id === "gourmet-dinner-plates"
      );
      break;
    case "snack-platters":
      productData = cardData.find((product) => product.id === "snack-platters");
      break;
    case "soup-salad-bowls":
      productData = cardData.find(
        (product) => product.id === "soup-salad-bowls"
      );
      break;
    case "party-serving-trays":
      productData = cardData.find(
        (product) => product.id === "party-serving-trays"
      );
      break;
    case "custom-shapes-sizes":
      productData = cardData.find(
        (product) => product.id === "custom-shapes-sizes"
      );
      break;
    default:
      productData = {}; // Handle case where no product is found
  }

  // Render the product data
  if (!productData.id) {
    return <div>Product not found</div>;
  }

  // FeaturedCard Component
  const FeaturedCard = ({ image, title }) => {
    return (
      <>
        <div className="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0">
          <div className="featured-block d-flex justify-content-center align-items-center">
            <p className="d-block pointer">
              <img
                src={image}
                className="featured-block-image img-fluid"
                alt={title}
              />
              <p className="featured-block-text">
                <strong>{title}</strong>
              </p>
            </p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Breadcrumb
        title="Eco-Palm Products"
        backgroundImage="./assets/img/contact-banner.png"
        height="40vh"
      ></Breadcrumb>
      <div className="container py-5">
        <div className="col-lg-12 col-12 text-center">
          <h2 className="mb-5 c-section-title uppercase">{productHeading}</h2>
        </div>
        <div className="row">
          {productData.cards.map((card) => (
            <FeaturedCard
              key={card.cardId}
              image={card.image}
              title={card.title}
            />
          ))}
        </div>
      </div>
    </>
  );
}
